import { type CampaignSource } from '../../types/campaign.types';
import { usePrizePopCardLiveData, type PrizePopCardLiveData } from './variants/usePrizePopCardLiveData';
import { useTournamentCardLiveData, type TournamentCardLiveData } from './variants/useTournamentCardLiveData';
import { useRebateCardData, type RebateCardData } from './variants/useRebateCardData';

export type CampaignCardLiveData = PrizePopCardLiveData & TournamentCardLiveData & RebateCardData;

/**
 * Composes every campaign variant's card live-data hook into one normalised shape.
 *
 * Each variant hook is ALWAYS called (stable hook order — Rules-of-Hooks-safe)
 * and self-gates by type, so the shared, type-agnostic card hooks (e.g.
 * useCampaignInfoItems) just read the result — no `campaignType === ...` checks
 * leak into them. Add a new variant by adding its `useXCardLiveData` hook and
 * spreading it here.
 */
export const useCampaignCardLiveData = (
  campaign: CampaignSource | null | undefined,
  isActive: boolean,
): CampaignCardLiveData => ({
  ...usePrizePopCardLiveData(campaign, isActive),
  ...useTournamentCardLiveData(campaign, isActive),
  ...useRebateCardData(campaign, isActive),
});
